// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ORFvU","toggleWrap":"styles_toggleWrap__2idWo","content":"styles_content__2AF8L","selectAreaCode":"styles_selectAreaCode__21bp3"};